import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16.016" width="1em" height="1em" {...props}><g fill="#474747"><path d="M0 5.015h2.484l2.97-3H6v12h-.475l-3.04-3H0z" style={{
        marker: "none"
      }} color="#bebebe" overflow="visible" /><path d="M15.031.016l-2 .737v14.525l2 .738zm-3 1.106l-2 .737v12.313l2 .738zM9 2.24l-2 .74v10.07l2 .742z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" /><path d="M15.031.016h-2v4.422l2-.364zm-3 0h-2v4.966l2-.363zM9 .016L7 0v5.535l2-.365zm-2 10.48v5.52h2V10.86zm3.031.553v4.967h2v-4.604zm3 .545v4.422h2v-4.059z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        marker: "none"
      }} color="#000" fontWeight={400} fontFamily="sans-serif" overflow="visible" opacity={0.35} /></g></svg>;
}

export default SvgComponent;